// removed by extract-text-webpack-plugin
module.exports = {"root":"error-page--root--37rUFc3W","message":"error-page--message--irqLBxiP","error-name":"error-page--error-name--G0OMnGxf","errorName":"error-page--error-name--G0OMnGxf","error-code":"error-page--error-code--2cnAtzad","errorCode":"error-page--error-code--2cnAtzad"};


//////////////////
// WEBPACK FOOTER
// ./views/error-page/styles.css
// module id = ./views/error-page/styles.css
// module chunks = 0